import Message from '@sats-group/ui-lib/react/message';
import React from 'react';
import ContentContainer from '~/client/components/content-container/content-container';
import PreviewLayout from '~/client/components/preview-layout/preview-layout';
import Showcase from '~/client/components/showcase/showcase';
import type { ShowcasePreview as Props } from './showcase-preview.types';

const ShowcasePreview: React.FC<Props> = ({ showcase }) => (
  <PreviewLayout>
    <div className="showcase-preview">
      {showcase ? (
        <Showcase {...showcase} />
      ) : (
        <ContentContainer>
          <Message text="No showcase props" />
        </ContentContainer>
      )}
    </div>
  </PreviewLayout>
);

export default ShowcasePreview;
